import { styled } from "@mui/material"

export const MainAreaContainer = styled("div")({
  gridArea: "main",
})
